import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsNhanVien, layDSNhanVienTheoQuyen } from '../../services/nhanvien';

const NhanVienSelectBox = ({ value, theoQuyen, optionAll, disabled, showAll, multiple, allowClear, onChange }: { value?: number, theoQuyen?: string; optionAll?: boolean, disabled?: boolean, showAll?: boolean, multiple?: boolean, allowClear?: boolean, onChange?: (e: any) => void }) => {
    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = theoQuyen ? await layDSNhanVienTheoQuyen(theoQuyen) : await layDsNhanVien(showAll);
            if (optionAll && rs.length > 1) {
                rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
            }
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        multiple ? 
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn nhân viên--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            disabled={disabled}
            value={value}
            mode= 'multiple'
            onChange={(e: number) => {
                if (onChange) {
                    onChange({
                        target: {
                            name: "nhanvien",
                            value: e
                        }
                    });
                }
            }}
            allowClear={allowClear}
            /> :

            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn nhân viên--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                options={data}
                disabled={disabled}
                value={value > 0 ?value: undefined}
                onChange={(e: number) => {
                    if (onChange) {
                        onChange({
                            target: {
                                name: "nhanvien",
                                value: e
                            }
                        });
                    }
                }}
                allowClear={allowClear}
            />
    );
};

export default NhanVienSelectBox;
